module.exports = __webpack_public_path__ + "static/assets/a3decd646cf3b861916c6b314df52896.svg";